import { api } from "../utils/api";

const getJobQueue = async () => {
  const res = await api.get("Jobs/myQueue");
  return res.data;
};

const getJobHistory = async ({ limit = 20, skip = 0, job, status } = {}) => {
  const res = await api.get("Jobs/myHistory", {
    params: { limit, skip, job, status }
  });
  return res.data;
};

const markAsRead = async jobId => {
  const res = await api.post(`Jobs/${jobId}/read`);
  return res.data;
};

const resendJob = async jobId => {
  const res = await api.post(`Jobs/${jobId}/resend`);
  return res.data;
};

const downloadJobFile = async jobId => {
  const res = await api.get(`Jobs/${jobId}/download`);
  return res.data;
};

const syncLb = async (forceFull = false) => {
  const res = await api.get("Jobs/syncLb", {
    params: forceFull ? { forceFull: true } : {}
  });
  return res.data;
};

const checkSyncLb = async () => {
  const res = await api.get("Jobs/checkSyncLb");
  return res.data;
};

const saveLbSyncSchedule = async schedule => {
  const res = await api.post("Jobs/saveLbSyncSchedule", schedule);
  return res.data;
};

const JobsService = {
  getJobQueue,
  getJobHistory,
  markAsRead,
  resendJob,
  downloadJobFile,
  syncLb,
  checkSyncLb,
  saveLbSyncSchedule
};

export default JobsService;
